import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => ({
    container: {
        marginTop: theme.spacing(2)
    }
});

type ButtonContainerProps = WithStyles<"container">

const ButtonContainer: React.SFC<ButtonContainerProps> = (props) => {
    const { classes } = props;
    return <Grid item>
        <Grid container justify="center" className={classes.container}>
            {props.children}
        </Grid>
    </Grid>
}

export default withStyles(styles)(ButtonContainer);


// WEBPACK FOOTER //
// ./src/components/ButtonContainer.tsx